import React from "react";
import { C } from "./theme";
import { VariantPicker } from "./Catalog";

// Petunjuk kontekstual di atas katalog (mode aktif, tool terpasang, pemilih varian)
export function EditorHints({ mode, tool, toolVid, onToolVid, moving }) {
  return (<>
        {/* Petunjuk kontekstual — tools kini di dock melayang kanan canvas */}
        {mode === "build" && tool && (
          <p data-testid="active-tool-hint" style={{ margin: "10px 2px 0", fontSize: 11, color: C.sub }}>
            Memasang: <b style={{ color: C.ink }}>{tool.name}</b> — klik petak untuk memasang, Esc untuk batal
          </p>
        )}
        {mode === "build" && tool && (tool.variants || []).length > 0 && (
          <VariantPicker def={tool} value={toolVid || ""} onChange={onToolVid} />
        )}
        {mode === "build" && !tool && moving === null && (
          <p style={{ margin: "10px 2px 0", fontSize: 11, color: C.t3 }}>
            Pilih gedung di bawah (otomatis mode Bangun), atau klik gedung terpasang untuk info/pindah/putar/hapus
          </p>
        )}
        {(mode === "road" || mode === "water" || mode === "runway") && (
          <p data-testid="draw-hint" style={{ margin: "10px 2px 0", fontSize: 11, color: C.sub }}>
            {mode === "road"
              ? "Seret untuk menggambar — jalan yang melewati sungai otomatis menjadi JEMBATAN; mobil & warga hanya menyeberang lewat jembatan"
              : mode === "runway"
              ? "Seret untuk menggambar LANDASAN PACU lebar 2 tile — marka tengah putih putus-putus + garis tepi; tanpa trotoar"
              : "Seret untuk menggambar sungai — lepas lalu seret lagi untuk berbelok"}
          </p>
        )}
        {mode === "move" && moving === null && (
          <p data-testid="move-hint" style={{ margin: "10px 2px 0", fontSize: 11, color: C.sub }}>
            Klik gedung terpasang untuk mengangkatnya, lalu klik petak tujuan
          </p>
        )}
        {mode === "rotate" && (
          <p data-testid="rotate-hint" style={{ margin: "10px 2px 0", fontSize: 11, color: C.sub }}>
            Klik gedung untuk memutarnya 90° searah jarum jam
          </p>
        )}
        {mode === "pan" && (
          <p data-testid="pan-hint" style={{ margin: "10px 2px 0", fontSize: 11, color: C.sub }}>
            Seret peta untuk menggeser tampilan, scroll untuk zoom
          </p>
        )}
        {moving !== null && (
          <p data-testid="moving-hint" style={{ margin: "10px 2px 0", fontSize: 11, color: C.warn, fontWeight: 600 }}>
            Mode pindah aktif — klik petak tujuan (hijau = bisa), Esc untuk batal
          </p>
        )}
  </>);
}
